export const API = {
  VENUE: {
    OVERVIEW: "/venues/:venue/overview",
    FINANCIALS: "/venues/:venue/financials",
    FINANCIALS_FOR_EVENT: "/event/:event/venues/:venue/financials",
    BRAND: "/venues/:venue/brands",
    REPRESENTATION_COMPANIES: "/venues/:venue/representation-companies"
  },
  HOTEL_GROUPS: {
    LIST: "/api/hotel-groups",
    LIST_FOR_PROGRAMMES: "/api/preferred-programmes/hotel-groups",
    LIST_TYPES: "/api/hotel-group-types",
    SINGLE_VIEW: "/api/hotel-groups/:id",
    DEAL_PERCENTAGE: "/api/hotel-groups/:id/deal-percentage/:programme",
    VENUE: "/api/hotel-groups/venues/:id",
    SINGLE_VIEW_FOR_PROGRAMMES: "/api/preferred-programmes/:id:programme",
    LOGO_IMAGE: "/api/hotel-groups/:id/logo",
    DOCUMENT: "/api/hotel-groups/:id/document",
    ACCOUNT_MANAGER: "/api/hotel-groups/:id/account-manager/:accountManagerId",
    UNASSIGN_ACCOUNT_MANAGER: "/api/hotel-groups/:id/account-manager/:accountManagerId/unassign",
    INVITE_USER: '/api/hotel-groups/:id/invite',
    USER_INVITES: '/api/hotel-groups/:id/invites',
    VENUES_EXPORT: '/api/hotel-groups/:id/venues/export',
    REPORTS: {
      SNAPSHOT: "/venues/report/snapshot",
    },
    USERS: {
      LIST: "/api/hotel-groups/:id/users"
    }
  },
  HOTEL_GROUP_VENUES: {
    LIST: "/api/hotel-groups/:id/venues",
    ADD: "/api/hotel-groups/:id/venues/add",
    SINGLE: "/venues/:venueSlug/overview",
    USER: {
      SINGLE: "/api/hotel-groups/users/:email",
      REMOVE: "/api/hotel-groups/users/:email/remove",
    },
  },
  SELF_SERVICE: {
    STRIPE: {
      GET_SUBSCRIPTION: "/:venueSlug/self-service/subscription/",
      GET_DEFAULT_PRODUCT: "/stripe/default-product",
      GET_PRICE: "/:venueSlug/self-service/price",
      APPLY_DISCOUNT: "/:venueSlug/self-service/apply-discount",
      CREATE_SESSION: "/:venueSlug/self-service/create",
      CREATE_SUBSCRIPTION: "/:venueSlug/self-service/create-subscription",
    },
  },
  QUICK_SEARCH: "/venues/quick",
};

export const FRONTEND = {
  UK_VENUE_LOCATIONS: "/uk-venue-locations",
  WORLDWIDE_VENUE_LOCATIONS: "/worldwide-venue-locations",
  VENUE: {
    PUBLIC_VIEW: "/venue/:venue",
    DASHBOARD: "/admin/venues",
    EDIT: "/admin/edit-venue/:venue/:section?",
    CALENDAR: "/admin/calendar",
  },
  MANAGE_VENUE_LICENCE: {
    INDEX: "/admin/venues/manage-licence",
    UPGRADE: "/admin/venues/manage-licence/upgrade",
    LICENSED_VENUE_PROMO_PAGE: "/admin/venues/manage-licence",
    PAYMENT_REDIRECT: "/admin/venues/manage-licence/:venueSlug/",
  },
  HOTEL_GROUPS: {
    INDEX: "/admin/venues/hotel-groups",
    SINGLE_VIEW: "/admin/venues/hotel-groups/:id",
    CREATE: "/admin/venues/hotel-groups/create",
  },
  PREFERRED_PROGRAMMES: {
    INDEX: "/admin/preferred-programmes",
    MY: "/admin/preferred-programmes/my-preferred-programme",
    VIEW: "/admin/preferred-programmes/hotel-group/:id/:programme",
    VIEW_VENUE: "/admin/preferred-programmes/venue/:id/:programme",
    VIEW_AGENCY: "/admin/preferred-programmes/hotel-group/:id/",
    EDIT: "/admin/preferred-programmes/:programme/hotel-group/:id/edit",
    CUSTOM_CREATE: "/admin/preferred-programmes/custom-group/create",
  },
  HOTEL_GROUPS_VENUE: {
    INDEX: "/admin/hotel-groups",
    SINGLE_EDIT: "/admin/hotel-groups/:id/edit",
    SINGLE_VIEW: "/admin/hotel-groups/:id/",
    SINGLE_VIEW_VENUE: "/admin/hotel-groups/venues/:id/",
    CREATE: "/admin/hotel-groups/create",
  },
};
